import classNames from 'classnames'
import FlightIcon from '@hashicorp/react-hds/src/components/flight-icon'
import s from './style.module.css'

interface ItemProps {
	iconName: string
	heading: string
}

export type IntroProps = {
	iconFill?: null | 'blue'
	items: Array<ItemProps>
} & (
	| { heading?: string; description?: never }
	| { heading?: never; description?: string }
)

export default function Intro({
	heading,
	description,
	iconFill,
	items,
}: IntroProps): JSX.Element {
	return (
		<div className={s.intro}>
			<div className={s.container}>
				<div className={s.inner}>
					{heading ? <h2 className={s.heading}>{heading}</h2> : null}
					{description ? (
						<h2 className={s.description}>{description}</h2>
					) : null}
					{items.length > 0 ? (
						<ul className={s.items}>
							{items.map((item, index) => {
								return (
									<li key={index} className={s.item}>
										<div
											className={classNames(
												s.icon,
												iconFill && iconFill === 'blue' && s.blue
											)}
										>
											<FlightIcon name={item.iconName} size={24} />
										</div>
										<p className={s.subHeading}>{item.heading}</p>
									</li>
								)
							})}
						</ul>
					) : null}
				</div>
			</div>
		</div>
	)
}
